import { schema } from 'normalizr'

export const onlineStatusSchema = new schema.Entity(
  'onlineStatus',
  {},
  { idAttribute: 'user' }
)
